(function () {
  var ATTR = 'data-media-alt';

  function filterMedia(variantAlt) {
    var alt = (variantAlt || '').trim();

    document.querySelectorAll('[data-media-item-id][' + ATTR + ']').forEach(function (el) {
      var mediaAlt = (el.getAttribute(ATTR) || '').trim();
      el.style.display = (mediaAlt === '' || mediaAlt === alt) ? '' : 'none';
    });

    document.querySelectorAll('[data-thumbnail-id][' + ATTR + ']').forEach(function (el) {
      var mediaAlt = (el.getAttribute(ATTR) || '').trim();
      el.style.display = (mediaAlt === '' || mediaAlt === alt) ? '' : 'none';
    });
  }

  function buildVariantAltMap(productData) {
    var mediaAltMap = {};
    if (productData && productData.media) {
      productData.media.forEach(function (m) { mediaAltMap[m.id] = m.alt || ''; });
    }
    var variantMap = {};
    if (productData && productData.variants) {
      productData.variants.forEach(function (v) {
        variantMap[v.id] = (v.featured_media && mediaAltMap[v.featured_media.id]) || '';
      });
    }
    return variantMap;
  }

  function init() {
    var container = document.querySelector('[data-saquito-alt-filter]');
    if (!container) return;

    var productJsonEl = document.querySelector('[id^="ProductJson-"]');
    if (!productJsonEl) return;

    var productData;
    try { productData = JSON.parse(productJsonEl.textContent); } catch (e) { return; }

    var variantMap = buildVariantAltMap(productData);

    filterMedia(container.getAttribute('data-initial-variant-alt') || '');

    container.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('change', function () {
        var idInput = form.querySelector('[name="id"]');
        if (!idInput) return;
        filterMedia(variantMap[parseInt(idInput.value, 10)] || '');
      });
    });

    document.addEventListener('product:variant-change', function (evt) {
      var v = evt.detail && evt.detail.variant;
      if (!v) return;
      filterMedia(variantMap[v.id] || '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
